import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';

export const functionMenuItemsTemplate  = (handleEdit, handleDelete, handleEditModule) => {

    return  [
        { id: 'edit', icon: EditIcon, text: 'Edit Function', color: 'blue', handler: handleEdit },
        { id: 'edit_module', icon: EditIcon, text: 'Edit Module', color: 'green', handler: handleEditModule },
        { id: 'delete', icon: DeleteIcon, text: 'Delete Function', color: 'red', handler: handleDelete }
    ];
}

